/* eslint-disable no-undef */
import * as React from "react";
import { tokens } from "@fluentui/react-theme";
import { inject, observer } from "mobx-react";
import { modelNames, views } from "./types";
import {
  makeStyles,
  Toolbar,
  ToolbarButton,
  Menu,
  MenuTrigger,
  MenuPopover,
  MenuList,
  MenuItem,
} from "@fluentui/react-components";
import {
  HistoryIcon,
  ChatIcon,
  GPTIcon,
  DocumentIcon,
  ChevronDownBlackIcon,
  ChevronDownWhiteIcon,
  ChevronLeftIcon,
} from "..";
import Store from "./store";

const useStyles = makeStyles({
  header: {
    boxShadow: tokens.shadow8Brand,
    width: "100%",
    display: "flex",
    flexDirection: "row",
    zIndex: 1,
    backgroundColor: "white",
  },
});

const Header = inject("store")(
  observer(({ store }: { store: Store }) => {
    function handleClick(model: modelNames) {
      store.setModel(model);
      store.setView(views.chat);
      store.setPrevious({
        ClientID: store.getClientID(),
        ConversationID: null,
        ModelType: store.model,
        Content: [],
        Summary: "",
        Filters: {
          case_laws: {
            laws: [],
            sections: [],
            keywords: [],
          },
          tax_guidances: {
            tax_guidances: [],
            tax_categories: [],
            keywords: [],
          },
          client_work: {
            document_classes: [],
            related_laws: [],
            keywords: [],
          },
        },
        TimeStamp: "",
        agent_mode: null,
        SelectedDocuments: [],
      });
      store.setGoback(false);
    }

    function handleClicktoChat() {
      store.setModel(store.getModel());
      store.setView(views.chat);
      store.setPrevious({
        ClientID: store.getClientID(),
        ConversationID: null,
        ModelType: store.model,
        Content: [],
        Summary: "",
        Filters: {
          case_laws: {
            laws: [],
            sections: [],
            keywords: [],
          },
          tax_guidances: {
            tax_guidances: [],
            tax_categories: [],
            keywords: [],
          },
          client_work: {
            document_classes: [],
            related_laws: [],
            keywords: [],
          },
        },
        TimeStamp: "",
        agent_mode: null,
        SelectedDocuments: [],
      });
      store.setGoback(false);
    }

    function handleBackClick() {
      store.setGoback(true);
      store.setView(views.chat);
    }

    const classes = useStyles();

    return (
      <div className={classes.header}>
        <Toolbar>
          {store.view == views.history ? (
            <ToolbarButton onClick={handleBackClick} icon={<ChevronLeftIcon />}>
              Back
            </ToolbarButton>
          ) : (
            <Menu>
              <MenuTrigger>
                <ToolbarButton appearance="primary" icon={<ChevronDownWhiteIcon />}>
                  {store.getModel()}
                </ToolbarButton>
              </MenuTrigger>

              <MenuPopover>
                <MenuList>
                  <MenuItem icon={<DocumentIcon />} onClick={() => handleClick(modelNames.documentModelName)}>
                    With docs
                  </MenuItem>
                  <MenuItem icon={<GPTIcon />} onClick={() => handleClick(modelNames.baseModelName)}>
                    GPT
                  </MenuItem>
                </MenuList>
              </MenuPopover>
            </Menu>
          )}
          <Menu>
            <MenuTrigger>
              <ToolbarButton icon={<ChevronDownBlackIcon />}>{store.getView()}</ToolbarButton>
            </MenuTrigger>

            <MenuPopover>
              <MenuList>
                <MenuItem icon={<ChatIcon />} onClick={() => handleClicktoChat()}>
                  Chat
                </MenuItem>
                <MenuItem icon={<HistoryIcon />} onClick={() => store.setView(views.history)}>
                  History
                </MenuItem>
              </MenuList>
            </MenuPopover>
          </Menu>
        </Toolbar>
      </div>
    );
  })
);

export default Header;
